module.exports = __webpack_public_path__ + "img/Small-Bevel-Attachment-25.9113bdea.png";